import Serializer from 'umg-ember-backend/serializers/application';

export default class ProductElementSerializer extends Serializer {
  attrs = {
    category: 'categoryId',
  };
}
